import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export default function RequiredLocationFields() {

    const [modalIsOpen, setIsOpen] = React.useState(false);


    function openModal() {
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }

    return (<>
        <Button color="primary" size="sm" id="required-fields-button" onClick={openModal}><i className='bi bi-info-circle'></i>{' '}Required Fields</Button>
        <Modal backdrop centered size="lg"
            isOpen={modalIsOpen}
            toggle={() => closeModal()}
        >
            <ModalHeader toggle={() => closeModal()}>
                Required fields (default field names)
            </ModalHeader>
            <ModalBody>
              <ul>
                <li><b>Name:</b>
                    <ul>
                        <li>name</li>
                    </ul>
                </li>
                <li><b>Location:</b>
                    <ul>
                        <li>Street Address and Region</li>
                        <ul>
                            <li>Street Address</li>
                            <ul>
                                <li>addr1</li>
                                OR
                                <li>addrnum, addrpredir, addrstreet, addrsuffix, addrpostdir, addrsectype, addrsecnum</li>
                            </ul>
                        AND
                            <li>Region</li>
                            <ul>
                                <li>zip</li>
                                OR
                                <li> City and State
                                    <ul>
                                        <li>city</li>
                                        AND
                                        <li>state</li>
                                    </ul>
                                </li>
                                OR
                                <li>lastline e.g. 'City, ST Zipcode'</li>
                            </ul>
                        </ul>
                    </ul>
                    OR
                    <ul>
                        <li>Latitude and Longitude</li>
                        <ul>
                            <li>latitude</li>
                            AND
                            <li>longitude</li>
                        </ul>
                    </ul>
                </li>
              </ul>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={() => closeModal()}>close</Button>
            </ModalFooter>
        </Modal>
    </>);
}
